import BaseEntityNew from 'client/components/core/BaseEntity/BaseEntityNew'
import { typedPageSelectors, usePage } from 'client/store'
import { EntityProps } from 'client/types'
import { SearchResults as CommonSearchResults } from 'common/components/entities/search-results'
import { searchResultsData } from 'common/components/entities/search-results/utils'
import { PageLocaleEnum } from 'common/enums/PageLocaleEnum'
import { SearchResultsInterface } from 'common/types/entities/search-results-interface'
import React, { useEffect, useState } from 'react'

interface SearchResultsProps extends EntityProps<SearchResultsInterface> {
  isSaveAllowed?: boolean
  isRemoveAllowed?: boolean
  isCopyAllowed?: boolean
}

export const SearchResults = ({
  entity,
  isMoveDownAllowed,
  isMoveUpAllowed,
  isSaveAllowed = true,
  isRemoveAllowed = true,
  isCopyAllowed = true,
}: SearchResultsProps) => {
  const locale = usePage(page => typedPageSelectors.getPageLocale(page))
  const [data, setData] = useState(searchResultsData(entity.maxItems))

  useEffect(() => {
    setData(searchResultsData(entity.maxItems))
  }, [entity.maxItems])

  return (
    <BaseEntityNew
      entity={entity}
      isMoveUpAllowed={isMoveUpAllowed}
      isMoveDownAllowed={isMoveDownAllowed}
      isSaveAllowed={isSaveAllowed}
      isRemoveAllowed={isRemoveAllowed}
      isCopyAllowed={isCopyAllowed}
    >
      <CommonSearchResults
        locale={locale as PageLocaleEnum}
        paginationCurrent={entity.maxItems}
        paginationTotal={3}
        resultsTotal={45}
        htmlAttrId={entity.htmlAttrId}
        data={data}
        card={entity.card}
        padding={entity.padding}
        mobilePadding={entity.mobilePadding}
        total={entity.total}
        title={entity.title}
        text={entity.text}
        date={entity.date}
        pagination={entity.pagination}
      />
    </BaseEntityNew>
  )
}
